import Button from '@v2/shared/components/Button';
import Container from '@v2/shared/components/Container';
import ReviewStars from '@v2/shared/components/ReviewStars';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowRight, faShieldCheck, faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import { Product } from '@v2/shared/lib/types';
import useHeaderHeight from '@v2/shared/lib/useHeaderHeight';
import bg from './images/magazine-collage.jpg';
import magzterGoldLogo from './images/magzter-gold-logo.png';

type Props = {
  product: Product;
};

/**
 * The hero. Fills the screen below the navigation, so the chevron at its foot sits on
 * the fold and says there is more underneath.
 */
export default function MainPanel({ product }: Props) {
  const headerHeight = useHeaderHeight();
  const reviews = product.reviews_data;

  return (
    <div
      style={{
        backgroundImage: `url(${bg})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
      }}
    >
      <Container
        className="flex flex-col items-center justify-center text-center relative"
        style={{ height: `calc(100vh - ${headerHeight}px)` }}
      >
        <h1 className="text-yellow-400 text-2xl sm:text-4xl md:text-5xl lg:text-6xl 2xl:text-7xl mb-5 lg:mb-7 font-bold max-w-7xl">
          Unlimited digital access to 10,000+ <br />
          magazines and newspapers
        </h1>
        <p className="text-white text-md sm:text-xl md:text-xl 2xl:text-2xl font-medium mb-8">
          Read on any device. Cancel anytime.
        </p>
        <Button
          color="yellow-400"
          size="lg"
          className="mb-3"
          iconAfter={faLongArrowRight}
          onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
        >
          Choose Your Plan
        </Button>
        <div className="text-white mb-10 text-sm">
          <FontAwesomeIcon icon={faShieldCheck} className="mr-2" />
          7-Day No Questions Asked Refund Guarantee
        </div>
        <span className="flex flex-col items-center mb-5">
          <span className="mr-3 font-normal text-white opacity-90">Powered by</span>
          <span>
            <img src={magzterGoldLogo} width="199" height="31" alt="Magzter Gold logo" />
          </span>
        </span>
        {reviews && (
          <div className="text-xl">
            <ReviewStars
              rating={reviews.rating}
              reviewsCount={reviews.count}
              onClick={() => document.getElementById('reviews')?.scrollIntoView({ behavior: 'smooth' })}
              invertedColors
            />
          </div>
        )}
        <FontAwesomeIcon icon={faAngleDown} className="text-white opacity-25 absolute bottom-8 w-full" size="3x" />
      </Container>
    </div>
  );
}
